import React from "react";

import { Box } from "@mui/material";

import MuiSelect from "components/molecules/MuiSelect";

const UsageSelect = ({ value, options, onChange }) => (
    <Box sx={{ mt: 1, mb: 3 }}>
        <MuiSelect
            value={value}
            options={options?.map((option) => ({
                label: option?.label,
                value: option?.id,
            }))}
            setValue={onChange}
            label="Usage"
            labelId="usage-select"
            multiple
            withChip
            disableCloseOnSelect
        />
    </Box>
);

export default UsageSelect;
